import { IndividualConfig } from 'ngx-toastr';
import { ProgressAnimationType } from 'ngx-toastr/toastr/toastr-config';
import { FaFontWeight, MuiIconFont } from '../icon';


export type MuiToastType = 'info'
  | 'danger'
  | 'warning'
  | 'success';

export interface MuiToastConfig extends IndividualConfig {
  toastType: MuiToastType;
  iconFont?: MuiIconFont;
  iconStyle?: FaFontWeight;
  icon?: string;
  hasAction?: boolean;
  actionText?: string;
}

export const DEFAULT_MUI_TOAST_INDIVIDUAL_CONFIG = {
  timeOut: 5000,
  extendedTimeOut: 0,
  progressBar: true,
  disableTimeOut: false,
  easeTime: 0,
  toastClass: 'mui-toast',
  positionClass: 'toast-bottom-right',
  progressAnimation: 'decreasing' as ProgressAnimationType,
  closeButton: false,
  tapToDismiss: true
};
